import { render, staticRenderFns } from "./UpdateRealmUser.vue?vue&type=template&id=61211706&"
import script from "./UpdateRealmUser.vue?vue&type=script&lang=js&"
export * from "./UpdateRealmUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports